export function geoFactory($resource, MyConstant) {
    "ngInject"

    return $resource(`${MyConstant.ApiUrl}geo/cities`, {}, {
        'cities': {
            cache: true,
            method: 'GET',
            url: `${MyConstant.ApiUrl}geo/cities`,
            params: { PageNumber: '@PageNumber', PageSize: '@PageSize', Filters: '@Filters' },
            isArray: false
        },
        'provinces': {
            cache: true,
            method: 'GET',
            url: `${MyConstant.ApiUrl}geo/provinces`,
            params: { PageNumber: '@PageNumber', PageSize: '@PageSize', Filters: '@Filters' },
            isArray: false
        },
        'countries': {
            cache: true,
            method: 'GET',
            url: `${MyConstant.ApiUrl}geo/countries`,
            params: { PageNumber: '@PageNumber', PageSize: '@PageSize', Filters: '@Filters' },
            isArray: false
        },
        'all': {
            cache: true,
            method: 'GET',
            url: `${MyConstant.ApiUrl}ECBTempGeneral/getcities`,
        },

    })
}


// WEBPACK FOOTER //
// ./src/factories/geo/geo.ts